
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Typography } from '@/components/atoms';
import WelcomeCoin from '@/components/atoms/WelcomeCoin/WelcomeCoin.vue';

@Component({
  components: {
    Typography,
    WelcomeCoin
  }
})
export default class OverviewAppOfferPreview extends Vue {
  @Prop() coins?: string;

  get business() {
    return this.$store.getters['business/getBusinessState'];
  }

  get businessLogo() {
    return this.business.logo.publicPath.small;
  }

  get currencySymbol() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }

  get coinsAmount() {
    return `${this.currencySymbol}${Number(this.coins) || 0}`;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }
}
